import * as React from "react";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { CGI_RED, languages, packages, versions } from "../helpers/enums";
import { Box, Button, MenuItem, Select } from "@mui/material";
import {
  fetchAssessmentAssignmentById,
  fetchAssessmentById,
} from "../helpers/apiRequests";

export default function InvokeGenerationApi({
  invokeGenerationApi,
  performedAssessmentId,
  assessmentAssignmentId,
  assessmentId,
  assesmentPackage,
  isNew = false,
}) {
  const { t, i18n } = useTranslation();

  function getCurrentLanguage() {
    const currentLanguage = i18n.resolvedLanguage?.toUpperCase();
    return Object.values(languages).includes(currentLanguage)
      ? currentLanguage
      : languages.EN;
  }

  const [generationLanguage, setGenerationLanguage] =
    React.useState(getCurrentLanguage);

  React.useEffect(() => {
    setGenerationLanguage(getCurrentLanguage());
  }, [i18n.resolvedLanguage]);

  return (
    <Box sx={{ display: "flex", flexDirection: "row" }}>
      <Button
        variant="contained"
        disabled={isNew}
        sx={{
          borderTopLeftRadius: 20,
          borderBottomLeftRadius: 20,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          textTransform: "none",
          height: 30,
          minWidth: 180,
          maxWidth: 180,
          boxShadow: "none",
        }}
        onClick={async () => {
          const assessmentData = await fetchAssessmentById(assessmentId);
          const assessmentAssignment = await fetchAssessmentAssignmentById(
            assessmentAssignmentId
          );
          const reqBody = {
            assessmentAssignmentID: assessmentAssignmentId,
            performedAssessmentID: performedAssessmentId,
            ownerGroups: assessmentAssignment.ownerGroups,
            assessmentID: assessmentId,
            selectedPackage: packages[assesmentPackage],
            selectedVersion: versions[assessmentData.type],
            language: generationLanguage,
          };
          invokeGenerationApi(reqBody);
        }}
        startIcon={<AddIcon />}
      >
        {t("newEvaluation")}
      </Button>
      <Select
        disabled={isNew}
        sx={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: 20,
          borderBottomRightRadius: 20,
          borderColor: CGI_RED,
          color: CGI_RED,
          height: 30,
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: CGI_RED,
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: CGI_RED,
            border: 1,
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: CGI_RED,
          },
          ".MuiSvgIcon-root ": {
            fill: CGI_RED + " !important",
          },
        }}
        value={generationLanguage}
        onChange={(e) => setGenerationLanguage(e.target.value)}
      >
        {Object.values(languages).map((lang) => (
          <MenuItem key={lang} value={lang}>
            {lang}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
